/// <reference path="../globals.d.ts" />

import Vue from '@src/vue'
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

export default class Cookies {
  private static store = (Vue as any).cookie

  static get (name) {
    return this.store.get(name)
  }

  static set (name, value, options = {}) {
    this.store.set(name, value, { ...options, domain: this.getDomain() })
  }

  static delete (name) {
    this.store.delete(name, { domain: this.getDomain() })
  }

  private static getDomain () {
    // NODE_ENV is replaced at build time, the specs always run with 'test'
    // istanbul ignore else
    if (NODE_ENV === 'development' || NODE_ENV === 'test') {
      return 'localhost'
    } else {
      return 'pixformance.com'
    }
  }

}
